import { render } from "./ModalAddUpdateVersion.vue?vue&type=template&id=6a0ea1a4"
import script from "./ModalAddUpdateVersion.vue?vue&type=script&lang=js"
export * from "./ModalAddUpdateVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__